export default __webpack_public_path__ + "static/media/flw.b5dd6af9.mp4";